/*打印目录*/
function myPrint(html){
  var newWindow=window.open("打印窗口","_blank");
  newWindow.document.write(html);
  newWindow.document.close();
  newWindow.print();
  newWindow.close();
}
$('.print-mulu').on('click', function(event) {
	event.preventDefault();
	/* Act on the event */
	var html = $("#printArea").html();
	myPrint(html)
});

 
/*伸缩控制按钮*/
(function(){
	$(".sec").each(function(index, el) {
		var pre = $(this).find('.p');
		if (pre.height()<422) {
			$(this).find('.switch').remove();
		}else{
			pre.addClass('short');
			/*防止隐藏内容闪现*/
			pre.closest('.pWap').removeAttr('style');
		}
	});

	$(".switch").on('click', function(event) {
		/* Act on the event */
		var that = $(this);
		if (that.hasClass('on')) {
			that.html('展开全部<i class="icon fs12 pl10">&#xe654;</i>').removeClass('on').addClass('off');
			that.siblings('.pWap').addClass('short');
		}else{
			that.html('收起<i class="icon fs12 pl10">&#xe654;</i>').removeClass('off').addClass('on');
			that.siblings('.pWap').removeClass('short');
		}
	});
})();

/*控制底部相关推荐轮播*/
(function(){
	var count = $('.sec4 #items').find('.item').length;
	var width = $('.sec4 #items .item').width()+16;
	$('.sec4 #items').width(count*width);
  var normalize_count = Math.ceil(count/4); //归一化（将4个作为一个整体）后的总数量
  var normalize_with = width*4;             //归一化（将4个作为一个整体）后的总宽度
	var current = 0;
  var go = function(n){
   $('#items').animate({"left":-n*normalize_with}, 500);
  };
// 前一个回来
  var prev = function(){
   current = (current-1)%normalize_count;
   if (current<0) {
    current = normalize_count-1;
   }
   go(current);
  }
  // 后一个出现
  var next = function(){
    current = (current+1)%normalize_count;
    go(current);
  };
  
  //相关推荐少于四个不显示左右两侧按钮
  if (count>4) {
   $('.sec4 .next').on('click',function(){next();});
   $('.sec4 .prev').on('click',function(){prev();});
   var autostart = setInterval(function(){
     next();
    },10000);
   $('.sec4').on({
     "mouseenter":function(){
       clearInterval(autostart);
     },
     "mouseleave":function(){
       autostart = setInterval(function(){
         next();
       },10000);
     }
    });
  }else{
   $('.sec4 .prev').addClass('hide');
   $('.sec4 .next').addClass('hide');
  }
})();


// WEBPACK FOOTER //
// ./src/pages/base/detail.js